import * as React from "react";

import type { AppTabListProps } from "./AppTabList.types";
import { AppTabListOverflowMenu } from "./AppTabListOverflowMenu";
import { AppTab } from "./AppTab";
import { dataUniqueId } from "@1js/acui-common";

const noOpFileMenuOpenId = "noOpFileMenuOpenId";

export const useTabs = (props: AppTabListProps): JSX.Element => {
  const {
    onFocus,
    onOverflowButtonExecute,
    onTabHeaderClick,
    overflowMenuLauncherLabel,
    overflowTabHeaderMenuLauncherIcon,
    overflowTabHeaders,
    topLevelTabHeaders,
    useNormalStyleForContextualTabs,
    keytipProps,
  } = props;

  const onTabSelect = React.useCallback(
    (tabID: string) => {
      onTabHeaderClick(tabID);
    },
    [onTabHeaderClick]
  );

  const tabs = topLevelTabHeaders.map((header) => {
    return (
      <AppTab
        {...header}
        data-unique-id={dataUniqueId(header)}
        key={header.id}
        value={header.id}
        onFocus={onFocus}
        onTabHeaderExecute={onTabHeaderClick}
        useNormalStyleForContextualTabs={useNormalStyleForContextualTabs}
        onKeyDown={header.onKeyDown}
        showTooltip={header.showTooltip}
      >
        {header.title}
      </AppTab>
    );
  });

  return (
    <>
      {tabs}
      <AppTabListOverflowMenu
        id="app-tab-list-overflow-menu"
        ariaLabel={overflowMenuLauncherLabel}
        topItems={topLevelTabHeaders}
        overflowItems={overflowTabHeaders || []}
        overflowTabHeaderMenuLauncherIcon={overflowTabHeaderMenuLauncherIcon}
        onMenuButtonClick={() =>
          onOverflowButtonExecute?.({ id: noOpFileMenuOpenId })
        }
        onOverflowButtonExecute={onOverflowButtonExecute}
        onMenuItemClick={(_event, id) => onTabSelect(id)}
        keytipProps={keytipProps}
      />
    </>
  );
};
